import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Card, CardContent, Grid } from '@mui/material';
import { AppContext } from '../context/AppContext';
import { parseTimeToSeconds, formatTime } from '../utils/timeUtils';
import { meetsStandard, getAgeGroup } from '../utils/dataUtils';

const EventTimes = () => {
  const { swimmerName, eventName } = useParams();
  const { swimmers, standards } = useContext(AppContext);
  const swimmer = swimmers[decodeURIComponent(swimmerName)];
  if (!swimmer) return <Typography>Swimmer not found</Typography>;

  const event = swimmer.events.find((e) => e.Event === decodeURIComponent(eventName));
  if (!event) return <Typography>Event not found</Typography>;

  const ageGroup = getAgeGroup(swimmer.info.Age);
  const juniorStandard = standards.juniorMets.find(
    (s) => s.Gender === swimmer.info.Gender && s['Age Group'] === ageGroup && s.Event === event.Event
  );
  const seniorStandard = standards.seniorMets.find(
    (s) => s.Gender === swimmer.info.Gender && s['Age Group'] === 'Open' && s.Event === event.Event
  );

  const times = swimmer.events
    .filter((e) => e.Event === event.Event)
    .sort((a, b) => parseTimeToSeconds(a.Best_Time) - parseTimeToSeconds(b.Best_Time));

  const fastestTime = times[0]?.Best_Time;

  return (
    <Container>
      <Typography variant="h1">{`${swimmer.info.Full_Name} - ${event.Event}`}</Typography>
      <Typography>Junior Mets Standard: {juniorStandard ? formatTime(juniorStandard['Qualifying Time']) : 'N/A'}</Typography>
      <Typography>Senior Mets Standard: {seniorStandard ? formatTime(seniorStandard['Qualifying Time']) : 'N/A'}</Typography>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {times.map((time, index) => {
          const timeSeconds = parseTimeToSeconds(time.Best_Time);
          const isSenior = seniorStandard && meetsStandard(time.Best_Time, seniorStandard['Qualifying Time']);
          const isJunior = juniorStandard && meetsStandard(time.Best_Time, juniorStandard['Qualifying Time']) && !isSenior;
          const isFastest = time.Best_Time === fastestTime && !isSenior && !isJunior;

          const backgroundColor = isSenior
            ? '#EF9A9A'
            : isJunior
            ? '#A5D6A7'
            : isFastest
            ? '#90CAF9'
            : 'inherit';

          return (
            <Grid item xs={12} key={index}>
              <Card sx={{ backgroundColor }}>
                <CardContent>
                  <Typography>Time: {formatTime(time.Best_Time)}</Typography>
                  <Typography>Date: {time.Date}</Typography>
                  <Typography>Meet: {time.Meet_Name}</Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default EventTimes;